<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('editTopic' )}}

            <v-spacer/>

            <v-tooltip open-on-hover bottom>
                <template v-slot:activator="{ on }">
                    <div v-on="getTopic.numberOfQuestions != 0 ? on : ''">
                        <v-btn :disabled="getTopic.numberOfQuestions != 0" @click="removing = true">
                            {{ $t('deleteTopic') }}
                            <v-icon right>delete</v-icon>
                        </v-btn>
                    </div>
                </template>
                <span>{{ $i18n.t('topicNotRemovable') }}</span>
            </v-tooltip>

            <v-btn @click="$store.commit('setEditTopicDialog', false)" class="ml-7">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-expand-transition>
                    <v-card v-show="removing" height="57" class="mx-auto">
                        <v-alert v-show="removing" outlined type="error" class="mb-n1">
                            <v-layout row>
                                <div  class="my-auto ml-4">
                                    {{ $i18n.t('confirmRemoveTopic') }}
                                </div>
                                <v-spacer/>
                                <v-btn @click="remove" color="red darken-1" class="mr-4">
                                    {{ $t('remove') }}
                                    <v-icon right>delete</v-icon>
                                </v-btn>
                                <v-btn @click="removing = false" class="mr-4">
                                    {{ $t('cancel') }}
                                </v-btn>
                            </v-layout>
                        </v-alert>
                    </v-card>
                </v-expand-transition>

                <v-form ref="form" @submit="submit">
                    <v-text-field v-model="name" :rules="topicNameRules" :placeholder="getTopic.name" :label="$i18n.t('title')">
                        <v-tooltip slot="append" v-if="name != getTopic.name" bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" @click="name = getTopic.name">replay</v-icon>
                            </template>
                            <span>{{ $t('undo') }}</span>
                        </v-tooltip>
                    </v-text-field>

                    <v-row>
                        <div class="my-auto mx-3">
                            {{ $i18n.t('topicNumber') }}
                        </div>
                        <v-col cols=2 class="my-n5">
                            <v-select :items="getTopics.map(topic => topic.position)" v-model="position" style="width: 100px">
                                <v-tooltip slot="append-outer" v-if="position != getTopic.position" bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="position = getTopic.position">replay</v-icon>
                                    </template>
                                    <span>{{ $t('undo') }}</span>
                                </v-tooltip>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            topicNameRules: [
                v => !!v || i18n.t('noTopicName'),
                v => !v || v.length <= 255 || i18n.t('longTopicName'),
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('updateTopic')
        },

        remove() {
            this.$store.dispatch('removeTopic')
        },
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getTopic',
            'getTopics',
            'getTopicName',
            'getTopicPosition',
            'isRemovingTopic',
        ]),
        name: {
            get() { return this.getTopicName },
            set(value) { this.$store.commit('setTopicName', value) },
        },
        position: {
            get() { return this.getTopicPosition },
            set(value) { this.$store.commit('setTopicPosition', value) },
        },
        removing: {
            get() { return this.isRemovingTopic },
            set(value) { this.$store.commit('setRemovingTopic', value) }
        }
    },
}
</script>
